import { useQuery } from 'react-query'
import { IClientRepository } from 'ufinet-web-functions'

export const useClientByIdQuery = (repository: IClientRepository, isEnabled = true, clientId: string | undefined) => {
	return useQuery(`client-${clientId}`, () => (clientId ? repository.find({ clientId: clientId }) : undefined), {
		enabled: isEnabled,
	})
}
